import React, { useContext } from 'react';
import './authStyle.scss';
// import { SecondaryButton, TextBox } from '../FormInput';
import { Grid, Hidden, Typography } from '@material-ui/core';
import { useState } from 'react';
// import { postAuthenticationDisbaledCode } from '../Service/authenticator-service';
// import AppContext from '../../App/AppContext';
import WarningIcon from '@material-ui/icons/Warning';
import PhonelinkOffIcon from '@material-ui/icons/PhonelinkOff';
// import { AppStorage } from '../Service/storage-service';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useWindowSize } from '../../../Core/Hooks/useWindowSize';
import { SecondaryButton, TextBox } from '../../../Core/Controls';
import { postAuthenticationDisbaledCode } from '../../../Core/Services/authenticator-service';
import { AppStorage } from '../../../Core/Basic/storage-service';
import { useToast } from '../../../Core/Hooks/useToast';
import { Alert } from '@material-ui/lab';
import OtpInput from '../../../Core/Controls/Otp_InputFields';
// import { useWindowSize } from '../Controls/ScreenResolution';

const TwoAuthDiasbledScreen = ({ onClose }) => {
    const [width, height] = useWindowSize();
    const [state, setState] = useState({
        code: ''
    });
    const [btnLoader, setBtnLoader] = useState(false);
    const { showToastSuccess, showToastWarning, showToastError } = useToast();

    // const { hideModal, showToast } = useContext(AppContext);
    const handleInput = (value) => {
        // const { value } = e.target;
        setState((st) => ({ ...st, code: value }));
    };

    const handleSubmit = async () => {
        try {
            setBtnLoader(true);
            let res = await postAuthenticationDisbaledCode(state.code);
            if (res.success) {
                AppStorage.setTwoFlag(false);
                showToastSuccess('Your login has been successfully disabled two-factor authentication. ');
                onClose && onClose();
            } else {
                showToastError(res.message);
            }
        } catch (error) {
            showToastError(error?.message || 'Something went wrong');
        } finally {
            setBtnLoader(false);
        }
    };
    return (
        <div className="authVerificationCode">
            <Hidden only={['sm', 'lg', 'md', 'xs']}>
                <div className="authMain">
                    <div className="authModal">
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <Grid Grid container justifyContent="center">
                                    <Grid item xs={12}>
                                        <div>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Alert severity="success">Two-factor Authentication is Enabled</Alert>
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <div className="stepText" style={{ textAlign: 'left' }}>
                                                        <div>
                                                            <span>Note</span> Verification Requirement
                                                        </div>
                                                        <span>We’ll ask for a verification code via your selected security method.</span>
                                                    </div>
                                                </Grid>

                                                {/* Step-like Info 2 */}
                                                <Grid item xs={12}>
                                                    <div className="stepText" style={{ textAlign: 'left' }}>
                                                        <div>
                                                            <span>Warning</span> Before Turning Off 2FA
                                                        </div>
                                                        <span>
                                                            Before you turn off two-factor authentication, understand that your login will rely only on username
                                                            and password without a verification code. This reduces the protection on your account.
                                                        </span>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <hr />
                            <Grid item xs={5}>
                                <Grid Grid container justifyContent="center">
                                    <Grid item xs={12}>
                                        <div className="qrScanner">
                                            <Typography variant="body1" style={{ textAlign: 'center', fontSize: 15, fontWeight: 600, marginBottom: 10 }}>
                                                Disable Two-Factor Authentication
                                            </Typography>{' '}
                                            <Typography variant="body1" style={{ textAlign: 'center', fontWeight: 600, color: '#1f3758' }}>
                                                <PhonelinkOffIcon style={{ fontSize: 90, color: '#E4421B' }} />
                                            </Typography>{' '}
                                            <span style={{ marginTop: 10 }}>
                                                <OtpInput length={6} onChange={(code) => handleInput(code)} />
                                            </span>
                                            <SecondaryButton isBtnLoader={btnLoader} fullWidth onClick={handleSubmit} style={{ marginTop: 20 }}>
                                                Submit
                                            </SecondaryButton>
                                        </div>

                                        {/* </div> */}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </Hidden>
            <Hidden only={['xl']}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={6}>
                        <Grid Grid container justifyContent="center">
                            <Grid item xs={12}>
                                <div>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Alert severity="success">Two-factor Authentication is Enabled</Alert>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <div className="stepText" style={{ textAlign: 'left' }}>
                                                <div>
                                                    <span>Note</span> Verification Requirement
                                                </div>
                                                <span>We’ll ask for a verification code via your selected security method.</span>
                                            </div>
                                        </Grid>

                                        {/* Step-like Info 2 */}
                                        <Grid item xs={12}>
                                            <div className="stepText" style={{ textAlign: 'left' }}>
                                                <div>
                                                    <span>Warning</span> Before Turning Off 2FA
                                                </div>
                                                <span>
                                                    Before you turn off two-factor authentication, understand that your login will rely only on username and
                                                    password without a verification code. This reduces the protection on your account.
                                                </span>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                    <hr />
                    <Grid item xs={12} sm={12} md={5}>
                        <Grid Grid container justifyContent="center">
                            <Grid item xs={12}>
                                <div className="qrScanner">
                                    <Typography variant="body1" style={{ textAlign: 'center', fontSize: 15, fontWeight: 600, marginBottom: 10 }}>
                                        Disable Two-Factor Authentication
                                    </Typography>{' '}
                                    <Typography variant="body1" style={{ textAlign: 'center', fontWeight: 600, color: '#1f3758' }}>
                                        <PhonelinkOffIcon style={{ fontSize: 90, color: '#E4421B' }} />
                                    </Typography>{' '}
                                    <span style={{ marginTop: 10 }}>
                                        <OtpInput length={6} onChange={(code) => handleInput(code)} />
                                    </span>
                                    <SecondaryButton isBtnLoader={btnLoader} fullWidth onClick={handleSubmit} style={{ marginTop: 20 }}>
                                        Submit
                                    </SecondaryButton>
                                </div>

                                {/* </div> */}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Hidden>
        </div>
    );
};

export default TwoAuthDiasbledScreen;
